import React from 'react';

import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

import { useExit } from 'src/hooks/useExit';

export function SessionExpired() {
    const exit = useExit();

    return (
        <>
            <div className="flex-1 space-y-6 text-center lg:flex-none">
                <FeaturedIcon size="lg" color="error" className="mx-auto mb-8" />
                <h1 className="mb-4 text-2xl font-medium text-gray-900">Your session has expired.</h1>
            </div>
            <Button className="mt-8 w-full" color="gray" onClick={() => exit()}>
                Exit
            </Button>
        </>
    );
}
